export interface IContentListFilterValues {
  name: string;
  website: string;
  contentListType: string;
  time: number;
}
export class ContentListFilterValues implements IContentListFilterValues {
  constructor(
    public name: string,
    public website: string,
    public contentListType: string,
    public time: number,
  ) {}
}
